<!--  -->
<template>
  <div class="outer">
    <div class="top-container">
      <div class="text-confirm">请确认信息</div>
    </div>
    <div class="content-container">
      <div class="information-container">
        <div class="name">{{ meetingInfo.name }}</div>
        <div class="cell">
          <div class="title">法会日期</div>
          <div class="content">
            {{ meetingInfo.activityBegin }} <span>至</span> <span> {{ meetingInfo.activityEnd }} </span>
          </div>
        </div>
      </div>
      <div class="buyer-container">
        <div class="buyer-title">信息登记</div>
        <div class="cell"
             style="display: none;">
          <div class="title">称谓</div>
          <div class="content"></div>
        </div>
        <div class="cell">
          <div class="title">姓名</div>
          <div class="content">{{userInfo.name}}</div>
        </div>
        <div class="cell">
          <div class="title">手机号码</div>
          <div class="content">{{userInfo.phone | phoneMask}}</div>
        </div>
        <div class="cell"
             style="display: none;">
          <div class="title">身份证号</div>
          <div class="content"></div>
        </div>
        <div class="cell">
          <div class="title">阳历生日</div>
          <div class="content">{{ userInfo.birthday }}</div>
        </div>
        <div class="cell">
          <div class="title">时辰</div>
          <div class="content">{{userInfo.times}}</div>
        </div>
        <div class="cell">
          <div class="title">性别</div>
          <div class="content">{{ userInfo.sex }}</div>
        </div>
        <div class="cell">
          <div class="title">居住地址</div>
          <div class="content">{{userInfo.province +" "+ userInfo.city +" "+  userInfo.area +" "+ userInfo.address }}</div>
        </div>
      </div>
      <div v-if="meetingInfo.type == 1"
           class="buyer-container line-gap">
        <div class="buyer-title">牌位信息</div>
        <div class="buyer-container"
             v-for="(memorials,index) in memorialsItems"
             :key="index"
             style="margin-left: 0px; padding-bottom: 0px;">
          <div class="cell"
               v-for="(items,index1) in memorials.items"
               :key="index1"
               v-if="items.name != ''">
            <div class="title">被超度人</div>
            <div class="content">{{items.identity}}{{items.name}}</div>
          </div>
          <div class="cell"
               v-for="(jzs,index2) in memorials.jzs"
               :key="index2">
            <div class="title">祭主{{ index2+1 }}</div>
            <div class="content">{{jzs}}</div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <div class="money-detail-wrap"
             style="display: flex;">
          <div class="money-wrap">
            <span class="symbol">¥</span>
            <span class="money">{{agenciesList == [] || agenciesList == '[]' ? meetingInfo?.sumPrice : (totalMoney * memorialsItemsList) + totalPrice }}</span>
          </div>
          <div class="detail-wrap"
               @click="showPriceDetail = !showPriceDetail">
            <span class="detail-text">明细</span>
            <img src="../assets/mingxijiantou.png"
                 alt="arrow-down"
                 class="order-price-fold">
          </div>
        </div>
        <div class="submit-order"
             @click="goToZhiFu">下一步</div>
      </div>
      <div class="price-detail-mask"></div>
      <van-popup class="order-price-container"
                 v-model="showPriceDetail"
                 position="bottom"
                 round>
        <img src="../assets/close.png"
             alt="close"
             @click="showPriceDetail = false">
        <div class="detail-title">价格明细</div>
        <div class="scroll-wrapper"
             style="height: 206px;">
          <div class="price-type">
            <div class="price-type-name">法会活动</div>
            <div class="price-type-money">￥{{ (totalMoney * memorialsItemsList)  }}</div>
            <!-- <div class="price-type-money">￥{{xianHuaDanJia}}</div> -->
          </div>
          <div class="cell">
            <div class="title">功德经资</div>
            <div class="money">¥{{ (totalMoney * memorialsItemsList)  }}</div>
            <!-- <div class="money">¥{{xianHuaDanJia}}</div> -->
          </div>
          <div class="price-type"
               style="margin-top: 15px;">
            <div class="price-type-name">待办服务</div>
            <div class="price-type-money">￥{{totalPrice}}</div>
          </div>
          <div v-for="(agencies,index) in agenciesList"
               :key="index"
               class="checkList-container">
            <div>
              <div class="cell">
                <div class="title">{{agencies.name}}</div>
                <div class="money">¥{{agencies.price}}x{{agencies.count}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <homeBtn />

    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import homeBtn from './homeBtn.vue'//首页按钮

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    homeBtn
  },
  data() {
    const memorialsItemsStr = localStorage.getItem("memorialsItems");
    const meetingInfoStr = localStorage.getItem("meetingInfo");
    const agenciesStr = localStorage.getItem("agencies");
    let memorialsItemsData = [];
    let meetingInfoData = {};
    let agenciesData = [];
    try {
      if (memorialsItemsStr) {
        memorialsItemsData = JSON.parse(memorialsItemsStr);
      }
      if (meetingInfoStr) {
        meetingInfoData = JSON.parse(meetingInfoStr);
      }
      if (agenciesStr && agenciesStr != [] && agenciesStr != "[]") {
        agenciesData = JSON.parse(agenciesStr);
      }
    } catch (error) {
      console.error("解析本地存储数据出现错误:", error);
    }
    return {
      memorialsItems: memorialsItemsData,
      memorialsItemsList: Array.isArray(memorialsItemsData) && memorialsItemsData.length >= 1 ? memorialsItemsData.length : 1,
      agenciesList: agenciesData,
      showPriceDetail: false,
      totalMoney: typeof meetingInfoData.price === 'number' ? Number(meetingInfoData.price) : 0,
      userInfo: {},
      meetingInfo: meetingInfoData
    };
  },
  filters: {
    phoneMask(phone) {
      if (phone && phone.length >= 11) {
        return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
      }
      return phone;
    },
    sumPrice(arr) {
      let sum = 0;
      arr.forEach(item => {
        sum += item.price * item.count;
      });
      return sum;
    }
  },
  // 监听属性 类似于data概念
  computed: {
    totalPrice() {
      let sum = 0;
      this.agenciesList.forEach(item => {
        sum += item.price * item.count;
      });
      console.log(sum)
      return sum;
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goToZhiFu() {
      function getLocalStorageData(key, defaultValue = null) {
        const value = localStorage.getItem(key);
        return value ? value : defaultValue;
      }

      let data = {
        activityId: this.meetingInfo.id,
        agencyItems: this.agenciesList,
        memorialsItems: this.memorialsItems,
        price: Number(this.meetingInfo.price),
        sumPrice: this.meetingInfo?.sumPrice + Number(this.agenciesList.reduce((acc, cur) => acc + (cur.price * cur.count), 0)),
        type: getLocalStorageData("orderType"),
        user: (getLocalStorageData("isAddUser") === "true") ? JSON.parse(getLocalStorageData("userInfo", {})) : null,
        userId: (getLocalStorageData("isAddUser") === "true") ? null : getLocalStorageData("addUserId"),
        isYj: getLocalStorageData("isYj") == "1" ? 1 : 0,
      };
      console.log(data)
      this.$http.post("/tempt/api/sjte/createOrder", data)
        .then((response) => {
          if (response.success) {
            this.$router.push({
              name: "quanbudingdandetailCopy",
              params: {
                orderInfo: response.result?.orderInfo
              },
            });
          } else {
            Toast.fail(response.message)
          }
          // this.wxPayOrder( response.result.orderId)
          console.log(response)
        })

      // this.$router.push("/zhifu")
    },
    onBridgeReady(wxData) {
      console.log("wxData", wxData);
      const { appId, timeStamp, nonceStr, packageInfo, signType, paySign } =
        wxData;
      console.log(
        "wxData",
        appId,
        timeStamp,
        nonceStr,
        packageInfo,
        signType,
        paySign
      );
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId,
          timeStamp: timeStamp,
          nonceStr: nonceStr,
          package: packageInfo,
          signType: signType,
          paySign: paySign,
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            queryOrder();
            setLoading(false);
          }
        }
      );
    },
    /**
     * 支付
     * @param {*} type
     */
    async wxPayOrder(orderId) {
      try {
        const { data } = await this.$http.get("/api/te/wxPayOrder", {
          params: {
            orderId: orderId,
          },
        });
        if (data.success) {
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            onBridgeReady(data.result);
          }
        } else {
          // showNotify({ type: 'danger', message: data.message });
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.meetingInfo = this.$store.state.meetingInfo || {};
    // if (!this.meetingInfo.id) { // 假设meetingInfo对象有id属性，可根据实际情况调整判断条件
    //   try {
    //     const meetingInfoFromStorage = localStorage.getItem("meetingInfo");
    //     if (meetingInfoFromStorage) {
    //       this.meetingInfo = JSON.parse(meetingInfoFromStorage);
    //     }
    //   } catch (error) {
    //     console.error("解析本地存储的meetingInfo出现错误:", error);
    //     // 根据业务需求设置合理的默认值，比如空对象等
    //     this.meetingInfo = {};
    //   }
    // }
    this.userInfo = this.$store.state.addUserInfo || {};
    if (!this.userInfo) {
      try {
        const userInfoFromStorage = localStorage.getItem("userInfo");
        if (userInfoFromStorage) {
          this.userInfo = JSON.parse(userInfoFromStorage);
        }
      } catch (error) {
        console.error("解析本地存储的userInfo出现错误:", error);
        this.userInfo = {};
      }
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.outer {
  padding-bottom: 82px;
}
.top-container {
  width: 100%;
  height: 139px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  overflow: hidden;
}
.top-container .text-confirm {
  font-size: 22px;
  color: #fff;
  margin-top: 42px;
  margin-left: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.content-container {
  width: 100%;
  border-radius: 16px 16px 0 0;
  margin-top: -16px;
  background-color: #fff;
}
.information-container {
  margin: 0 16px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(51, 51, 51, 0.1);
}
.information-container .name {
  font-size: 18px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Semibold, PingFang SC;
}
.cell {
  margin-top: 8px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
  width: 80px;
}
.cell .content {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin-left: 20px;
  font-size: 14px;
  color: #000;
  width: 75%;
  font-family: PingFangSC-Regular, PingFang SC;
}
.buyer-container {
  margin: 0 16px;
  padding: 16px 0;
}
.buyer-container .buyer-title,
.money-container .money-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
}
.line-gap {
  border-top: 1px solid rgba(51, 51, 51, 0.1);
}
.buyer-container {
  margin: 0 16px;
  padding: 16px 0;
}
.buyer-container .buyer-title,
.money-container .money-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
}
.buyer-container {
  margin: 0 16px;
  padding: 16px 0;
}

/* 底部信息 */
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background-color: #fff;
  -webkit-box-shadow: inset 0 1px 0 0 #eee;
  box-shadow: inset 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 32px;
  z-index: 2999;
}
.scroll-wrapper {
  max-height: 290px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  height: 206px;
}
.price-type {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  line-height: 22px;
  color: #000;
}
.price-type-name {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.price-type-money {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.communion-price,
.order-price-container .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 43px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.order-price-container .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
  margin-bottom: 4px;
}
.order-price-container .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
.checkList-container {
  padding-bottom: 20px;
}

.bottom-container .money-wrap .symbol {
  font-size: 14px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .money-wrap .money {
  font-size: 20px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .detail-wrap {
  margin: 2px 0 2px 8px;
}

.detail-wrap img {
  margin-left: 5px;
}

.bottom-container .detail-wrap .detail-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}

.bottom-container .detail-wrap > img {
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
}
.submit-order {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  margin-left: 43px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}
.van-popup--bottom {
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
  z-index: 201;
  min-height: 148px;
  max-height: 400px;
  padding: 16px 16px 72px;
  overflow: hidden;
  width: auto;
}

.van-popup--bottom img {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 10px;
}
.van-popup--bottom .detail-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  text-align: center;
}
.van-popup--bottom {
  max-height: 290px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.van-popup--bottom .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 8px;
}

.van-popup--bottom .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
}

.van-popup--bottom .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}
</style>
